import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import HeaderTitle from '../HeaderTitle';
import { Button } from '../Form';
import Icon from '../Icon';
import classNames from '../../utils/classNames';
import api from '../../utils/api';
import withTranslations from '../../utils/translations/withTranslations';

import Personal from './Personal';
import Practice from './Practice';
import Account from './Account';

import './Register.css';

class Register extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      activeSteps: {
        personal: true,
        practice: false,
        account: false
      },
      currentStep: 'personal',
      data: {},
      steps: {
        personal: Personal,
        practice: Practice,
        account: Account
      },
      success: false
    };
  }

  store(data, callback = () => {}) {
    this.setState(
      prevState => ({
        data: _.assign(prevState.data, data)
      }),
      () => callback()
    );

    this.next();
  }

  next() {
    const nextIndex = this.currentIndex() + 1;
    const steps = Object.keys(this.state.steps);

    if (nextIndex < steps.length) {
      this.goTo(steps[nextIndex]);
    }
  }

  previous() {
    this.goTo(Object.keys(this.state.steps)[this.currentIndex() - 1]);
  }

  currentIndex() {
    const { steps, currentStep } = this.state;

    return Object.keys(steps).indexOf(currentStep);
  }

  save() {
    return api
      .post('/auth/register', { body: this.state.data })
      .then(() => this.setState({ success: true }));
  }

  goTo(item) {
    this.setState(prevState => ({
      currentStep: item,
      activeSteps: {
        ...prevState.activeSteps,
        [item]: true
      }
    }));
  }

  render() {
    const { steps, activeSteps, currentStep, data, success } = this.state;
    const { translate } = this.props;

    const stepNames = Object.keys(steps);
    const CurrentStep = steps[currentStep];

    return (
      <div className="Register">
        <div className="Register__Header">
          <HeaderTitle />
        </div>
        {success && (
          <div className="Register__Success">
            <Icon name="success" className="Register__Success__Icon" />
            <h1 className="Register__Success__Title">{translate('register.successful.title')}</h1>
            <div className="Register__Success__Paragraph">
              {translate('register.successful.message')} ({data.email})
            </div>
            <Button solid className="Register__Success__Login" onClick={() => this.props.history.push('/')}>
              {translate('register.successful.login')}
            </Button>
          </div>
        )}
        {!success && (
          <div>
            <div className="Register__Progress">
              {stepNames.map(step => (
                <div
                  className={classNames(
                    'Register__Progress__Step',
                    activeSteps[step] && 'Register__Progress__Step--active'
                  )}
                  key={step}
                >
                  <div className="Register__Progress__Step__Title">{translate('register.items.' + step)}</div>

                  <div className="Register__Progress__Step__Indicator">
                    <div />
                    <span>
                      <span />
                    </span>
                    <div />
                  </div>
                </div>
              ))}
            </div>
            <div className="Register__Content">
              <CurrentStep
                store={(data, callback) => this.store(data, callback)}
                previous={() => this.previous()}
                save={() => this.save()}
                data={data}
                translate={translate}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withTranslations(Register));
